var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPresentCrossSectionSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d0d0d7;}.cls-2{fill:#aeaeb6;}.cls-3{fill:#363545;}.cls-4{fill:none;stroke:#be1e2d;stroke-miterlimit:10;stroke-width:5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PresentCrossSection_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4,10.45V17H6V9.2A12.88,12.88,0,0,0,4,10.45Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.26,10.2,13.32,9c-2.63-.79-2.88-.86-3.58-.85A8,8,0,0,0,8,8.43V17H8a11.38,11.38,0,0,1,5.64-1.83c1,0,1.52.12,4.22.94l3,.89H28V10.55a6.16,6.16,0,0,1-.94.59C24.73,12.32,22.37,11.7,17.26,10.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.83,17.28A32.71,32.71,0,0,0,28,18.74V17H20.88Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8,17l0,0H8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.74,8.17c.7,0,.95.06,3.58.85l3.94,1.18c5.11,1.5,7.47,2.12,9.8.94a6.16,6.16,0,0,0,.94-.59V7.72a5.16,5.16,0,0,1-1.83,1.64c-1.6.79-3.35.39-8.34-1.08L13.9,7.11c-2.7-.82-3.19-1-4.22-.94A9.67,9.67,0,0,0,8,6.39v2A8,8,0,0,1,9.74,8.17Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.26,19.2,17.32,18c-2.63-.79-2.88-.86-3.58-.85A10.1,10.1,0,0,0,8,19.45V26H32V19.55a6.16,6.16,0,0,1-.94.59C28.73,21.32,26.37,20.7,21.26,19.2Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.17,18.36c-1.6.79-3.35.39-8.34-1.08L17.9,16.11c-2.7-.82-3.19-1-4.22-.94A11.42,11.42,0,0,0,8,17V2H6V26H2v2H6v4H8V28H32V26H8V19.45a10.1,10.1,0,0,1,5.74-2.28c.7,0,.95.06,3.58.85l3.94,1.18c5.11,1.5,7.47,2.12,9.8.94a6.16,6.16,0,0,0,.94-.59V16.72A5.16,5.16,0,0,1,30.17,18.36Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6,9.2V7A13.9,13.9,0,0,0,4,8V0H2V17H0v2H2v4H4V19H6V17H4V10.45A12.88,12.88,0,0,1,6,9.2Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -164.15,
    y: -58.62,
    width: 307.49,
    height: 95.32
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentCrossSectionSvg);
export default __webpack_public_path__ + "static/media/PresentCrossSection_svg.e9ae6a3e64e406604109f38ea8325fb9.svg";
export { ForwardRef as ReactComponent };